package com.parmartechnologies.storage.table.cart

import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class CartItemDatabaseTable : DatabaseTable() {
    fun insert(item: CartItem?, callback: () -> Unit) {
        item?.let {
            DatabaseCollection().insert(item, CartItem.serializer())
        }
    }

    fun insert(items: List<CartItem>?, callback: () -> Unit) {
        items?.forEach { item ->
            insert(item) {}
        }
        callback()
    }

    fun update(item: CartItem?, callback: () -> Unit) {
        item?.let {
            DatabaseCollection().updateOne(item, CartItem.serializer())
        }
    }

    fun update(item: CartItem) {
        val andQuery : Map<String,Any?> = mapOf(Pair("product_id", item.product._id))
        DatabaseCollection().updateOne(item, andQuery, CartItem.serializer())
    }

    fun delete(id: String) {
        DatabaseCollection().delete(id,CartItem.serializer())
    }

    fun deleteInventory(id: String, inventoryId: String) {

    }

    fun deleteAll() {
        DatabaseCollection().deleteAll(CartItem.serializer())
    }

    fun retrieve(id: String, callback: (List<CartItem>) -> Unit) {

    }



    fun retrieveForProduct(id: String, callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("id",id))
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }

    fun retrieveForCustomer(id: String, customerId: String, callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",id),Pair("customer_id",customerId))
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }

    fun retrieveForBusiness(id: String, callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("business_id",id))
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }

    fun retrieveForUser(id: String, userId: String, callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",id),Pair("user_id",userId))
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }

    fun retrieveForGuest(id: String, callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",id))
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }

    fun retrieve(callback: (List<CartItem>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf()
        DatabaseCollection().findAll(andQuery,CartItem.serializer()){
            callback(it)
        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
//        val table = AppDatabase.shared().database?.productTableQueries
//        scope.launch {
//            val dateFromDb = table?.LastSyncDate(id)?.awaitAsOneOrNull()
//            callback(dateFromDb?.UpdatedAt)
//        }
    }


//    fun convert(item: CartItemTable, callback: (CartItem) -> Unit) {
//        try {
//            val prd = jsonDecoder.decodeFromString<Product>((item.Product ?: Product()).toString())
//            val inv = jsonDecoder.decodeFromString<Inventory>((item.Inventory ?: Inventory()).toString())
//            callback(
//                CartItem(
//                    uniqueID = item.UniqueID,
//                    _id = item._id,
//                    UserID = item.UserID,
//                    BusinessID = item.BusinessID,
//                    selectedBusinessID = item.SelectedBusinessID,
//                    customerId = item.CustomerId,
//                    productId = item.ProductID ?: "",
//                    inventoryId = item.InventoryID ?: "",
//                    product = prd,
//                    inventory = inv,
//                    price = jsonDecoder.decodeFromString(item.Price ?: ProductPrice().toString()),
//                    quantity = item.Quantity,
//                    finalPrice = item.FinalPrice,
//                    createdAt = item.CreatedAt,
//                    updatedAt = item.UpdatedAt,
//                )
//            )
//        } catch (error: Exception) {
//            ProductDatabaseTable().find(item.ProductID ?: "") { product:Product? ->
//                if (product != null) {
//                    val inv = jsonDecoder.decodeFromString<Inventory>((item.Inventory ?: Inventory()).toString())
//                    callback(
//                        CartItem(
//                            uniqueID = item.UniqueID,
//                            _id = item._id,
//                            UserID = item.UserID,
//                            BusinessID = item.BusinessID,
//                            selectedBusinessID = item.SelectedBusinessID,
//                            customerId = item.CustomerId,
//                            productId = item.ProductID ?: "",
//                            inventoryId = item.InventoryID ?: "",
//                            product = product,
//                            inventory = inv,
//                            price = jsonDecoder.decodeFromString(
//                                item.Price ?: ProductPrice().toString()
//                            ),
//                            quantity = item.Quantity,
//                            finalPrice = item.FinalPrice,
//                            createdAt = item.CreatedAt,
//                            updatedAt = item.UpdatedAt,
//                        )
//                    )
//                }
//            }
//        }
//    }
}